'use es6';

import { useEffect } from 'react';

var getRenderFunc = function getRenderFunc(useRecaptchaEnterprise) {
  return useRecaptchaEnterprise ? window.grecaptcha.enterprise.render : window.grecaptcha.render;
};

var loadScript = function loadScript(_ref) {
  var sitekey = _ref.sitekey,
      onLoad = _ref.onLoad,
      onSuccess = _ref.onSuccess,
      onExpired = _ref.onExpired,
      locale = _ref.locale,
      useRecaptchaEnterprise = _ref.useRecaptchaEnterprise,
      baseUrl = _ref.baseUrl;

  window.hsRecaptchaLoaded = function () {
    var widgetId = getRenderFunc(useRecaptchaEnterprise)('hsRecaptchaTarget', {
      sitekey: sitekey,
      callback: onSuccess,
      'expired-callback': onExpired,
      size: 'invisible',
      badge: 'inline'
    }, true);
    onLoad(widgetId);
  };

  var script = document.createElement('script');
  var path = useRecaptchaEnterprise ? 'enterprise' : 'api';
  script.async = true;
  script.defer = true;
  script.id = 'recaptcha';

  script.onerror = function (error) {
    throw error;
  };

  script.src = baseUrl + "/" + path + ".js?&onload=hsRecaptchaLoaded&render=explicit&hl=" + locale;
  script.type = 'text/javascript';
  document.body.appendChild(script);
};

export default (function (_ref2) {
  var onLoad = _ref2.onLoad,
      onSuccess = _ref2.onSuccess,
      sitekey = _ref2.sitekey,
      locale = _ref2.locale,
      onExpired = _ref2.onExpired,
      useRecaptchaEnterprise = _ref2.useRecaptchaEnterprise,
      baseUrl = _ref2.baseUrl;
  useEffect(function () {
    loadScript({
      sitekey: sitekey,
      onLoad: onLoad,
      onSuccess: onSuccess,
      locale: locale,
      onExpired: onExpired,
      useRecaptchaEnterprise: useRecaptchaEnterprise,
      baseUrl: baseUrl
    });
  }, [sitekey, onLoad, onSuccess, locale, onExpired, useRecaptchaEnterprise, baseUrl]);
});